<div class="max-width-lg bg-gradient pt-60">
  <div class="flex-col">
    <div class="flex flex-row">
      <div class="tab-overview tab active ml-46" [ngClass]="{ 'active': selectedTab === TabId.OVERVIEW }" (click)="selectedTab = TabId.OVERVIEW">
        <button class="btn-link" [ngClass]="{ 'active': selectedTab === TabId.OVERVIEW }">{{ 'SERVICE.OVERVIEW' | transloco }}</button>
      </div>
      <!-- <div class="tab-tutorials-and-documents tab" [ngClass]="{ 'active': selectedTab === TabId.TUTORIALS_AND_DOCUMENTS }" (click)="selectedTab = TabId.TUTORIALS_AND_DOCUMENTS">
        <button class="btn-link" [ngClass]="{ 'active': selectedTab === TabId.TUTORIALS_AND_DOCUMENTS }">{{ 'SERVICE.USERGUIDES' | transloco }}</button>
      </div> -->
    </div>
  </div>
</div>
<div class="w-100-percent">
    <div *ngIf="service" class="mr--12 ml--12">
      <app-overview-view *ngIf="selectedTab === TabId.OVERVIEW" [solutionVersion]="solutionVersion" [service]="service" [capabilityDescription]="capabilityDescription" [capabilities]="capabilities" [selectedCapabilities]="selectedCapabilities" [displayStartFreeTrialButton]="displayStartFreeTrialButton"></app-overview-view>
      <!-- <app-tutorials-documents-view *ngIf="selectedTab === TabId.TUTORIALS_AND_DOCUMENTS" [service]="service"></app-tutorials-documents-view> -->
    </div>
</div>
